import React, { useState, useEffect, useRef } from "react";
import { API_URL, getValFromLS, fmtCurrency } from "../helpers";
import Alert from "../components/Alert";
import Msg from "../components/Msg";

const Form3 = ({ update }) => {
	const [details, setDetails] = useState({
		donations: [],
		contacts: [],
	});
	const [msg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const formElement = useRef(null);

	useEffect(() => {
		init();
	}, []);

	const init = async () => {
		const token = getValFromLS("friendsDash", true)
			? getValFromLS("friendsDash", true)
			: "";

		const url = new URL(`${API_URL}/auth/friendsDashForm3Init`);
		const params = {
			token,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setDetails({ ...json });
				setAlert({});
			} else {
				setAlert({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<Alert data={alert} />
			) : (
				<>
					<form
						ref={formElement}
						method="post"
						action="/"
						onSubmit={(e) => {
							e.preventDefault(e);
						}}
						className="well"
					>
						<h3 style={{ marginTop: "0" }}>Your Donors</h3>

						<p>
							Below are the Champion <i>fore</i> Charity donations received for{" "}
							<strong>{details.charityName}</strong> under your friendraiser
							account.
						</p>

						<div>
							<table className="donors-table">
								<thead>
									<tr>
										<th
											colSpan="4"
											style={{ paddingTop: "15px", paddingBottom: "15px" }}
										>
											<h2 style={{ marginTop: "0px", marginBottom: "7.5px" }}>
												{details.total || `$0.00`}
											</h2>
											<p
												style={{
													margin: "0",
													padding: "0",
													fontSize: "1.15rem",
												}}
											>
												2026-2027 Donations to Date
											</p>
										</th>
									</tr>
									<tr>
										<td className="center" style={{ width: "10%" }}>
											Date
										</td>
										<td className="left">Name</td>
										<td className="center">Email</td>
										<td className="center" style={{ width: "20%" }}>
											Amount
										</td>
									</tr>
								</thead>
								{details.donations.length > 0 ? (
									<tbody>
										{details.donations.map((donation) => {
											return (
												<tr key={donation.id}>
													<td className="center">{donation.date}</td>
													<td className="left">{donation.name}</td>
													<td className="center">{donation.email}</td>
													<td className="right">{donation.amt}</td>
												</tr>
											);
										})}
									</tbody>
								) : (
									<tbody>
										<tr>
											<td
												colSpan="4"
												className="center"
												style={{ paddingTop: "15px", paddingBottom: "15px" }}
											>
												— no donations recorded yet —
											</td>
										</tr>
									</tbody>
								)}
							</table>
						</div>

						<div className="msg-submit">{msg.type && <Msg data={msg} />}</div>
					</form>

					<table className="approved" style={{ marginBottom: "25px" }}>
						<thead>
							<tr>
								<th
									colSpan="4"
									className="left"
									style={{ padding: "15px", fontSize: "20px" }}
								>
									Your Contacts
								</th>
							</tr>
							<tr>
								<th style={{ padding: "10px" }}>Name</th>
								<th style={{ padding: "10px" }}>Email</th>
								<th style={{ padding: "10px" }}>Phone</th>
								<th style={{ padding: "10px" }}>Amount</th>
							</tr>
						</thead>
						{details.contacts.length > 0 ? (
							<tbody>
								{details.contacts.map((item) => {
									return (
										<tr key={item.id}>
											<td className="center">{item.name}</td>
											<td className="center">
												<a href={`mailto:${item.email}`}>{item.email}</a>
											</td>
											<td className="center">{item.phone}</td>
											<td className="center">
												{fmtCurrency(item.total / 100)}
											</td>
										</tr>
									);
								})}
							</tbody>
						) : (
							<tbody>
								<tr>
									<td
										colSpan="4"
										className="center"
										style={{ paddingTop: "15px", paddingBottom: "15px" }}
									>
										— no contacts yet, scan the QR code above to manage via your
										phone —
									</td>
								</tr>
							</tbody>
						)}
					</table>
				</>
			)}
		</>
	);
};

export default Form3;
